
<div class="_dialog-title">
  <input class="offer-search" [(ngModel)]="searchCriteria" (ngModelChange)="onSearchChange($event)" type="text" [placeholder]="'TD.find_offers' | translate" (click)="$event.stopPropagation()" />
  <button mat-mini-fab (click)="cancel()" >
    <mat-icon aria-label="Close Dialog">close</mat-icon>
  </button>
</div>

<div class="_dialog-content border-top" [class._dialog-content-back]="!selectedOffers.length">
  <div class="offers-menu-cat" [@stagger]="showStagger" style="background-color:#fff; border-bottom-width: 0">
    <menu-offers-container>
      @for (offer of selectedOffers; track offer._id) {
        <div class="menu-offer"
          [id]="'cat_' + offer._id"
          (mousedown)="menuItemClick(offer,$event)"
          [ngClass]="{'_active':$storage.order.offerCounters[offer.offer], '_folder':offer.type == 'folder', '_disabled': offer.stockDisabled}">
          <div class="menu-offer-body">
            <div class="_body">
              <div class="menu-offer-title">{{offer.name}}</div>
              @if (offer.description_display != 'hide') {
                <div class="menu-offer-description">{{offer.description}}</div>
              }
              <div class="menu-offer-price">
                @if (offer.price > 0) {
                  <div class="_price">{{offer.price | lcurrency}}</div>
                } @else {
                  <div class="_price"></div>
                }
                <app-offer-attributes [offer]="offer"></app-offer-attributes>
              </div>
            </div>
            <!--[class.no-image]="offer.iconImage" [appBgImage]="offer.imageURL" [model]="cat"-->
            <div class="_image" [ngStyle]="offer.catStyle || offer.cardStyle" [class.stock-disabled]="offer.stockDisabled">
              <img [appImageSrc]="offer.imageURL" [model]="offer" loading="lazy" />
              <app-offer-marketing [offer]="offer" [$storage]="$storage"></app-offer-marketing>
            </div>
          </div>
        </div>
      }
    </menu-offers-container>
  </div>
</div>

